const SortingStorageKeys = {
    COLUMN: 'kw_sorting_by',
    DIRECTION: 'kw_sorting_direction',
};

export default SortingStorageKeys;
